// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3A8VZ","gfeWrapper":"CalendarEvent_gfeWrapper__2pa_e"};